// src/components/AdminNav.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ChevronDown, User, Settings, LogOut } from 'lucide-react';
import RoleSwitcher from './RoleSwitcher';

const AdminNav = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
        {/* Logo - Left */}
        <Link to="/admin" className="flex items-center gap-2 group">
          <img
            src="/newaudia-logo.jpg"
            alt="NewAudia™"
            className="h-10 sm:h-12 md:h-16 w-auto object-contain rounded transition-transform group-hover:scale-105"
          />
        </Link>

        {/* Right Side - Role Switcher + Admin Menu */}
        <div className="flex items-center gap-3">
          {/* Role Switcher for multi-role users */}
          <RoleSwitcher />
          
          {/* Admin Menu */}
          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center gap-2 rounded-full bg-amber-900/50 px-3 py-2 text-sm font-medium text-amber-200 hover:bg-amber-900 transition-colors border border-amber-700/50"
            >
              <User className="h-4 w-4" />
              <span className="hidden sm:inline">{user?.first_name || user?.email?.split('@')[0] || 'Admin'}</span>
              <ChevronDown className="h-4 w-4" />
            </button>

            {/* Dropdown Menu */}
            {showUserMenu && (
              <>
                {/* Backdrop */}
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setShowUserMenu(false)}
                />
                
                {/* Menu - Admin-appropriate options only */}
                <div className="absolute right-0 mt-2 w-56 rounded-lg border border-slate-700 bg-slate-900 py-2 shadow-xl z-50">
                  <Link
                    to="/admin/system"
                    className="flex items-center gap-3 px-4 py-2 text-sm text-slate-200 hover:bg-slate-800 transition-colors"
                    onClick={() => setShowUserMenu(false)}
                  >
                    <Settings className="h-4 w-4" />
                    Platform Settings
                  </Link>
                  <Link
                    to="/account/profile"
                    className="flex items-center gap-3 px-4 py-2 text-sm text-slate-200 hover:bg-slate-800 transition-colors"
                    onClick={() => setShowUserMenu(false)}
                  >
                    <User className="h-4 w-4" />
                    My Profile
                  </Link>
                  <div className="my-1 border-t border-slate-700" />
                  <button
                    onClick={() => {
                      setShowUserMenu(false);
                      handleLogout();
                    }}
                    className="flex w-full items-center gap-3 px-4 py-2 text-left text-sm text-red-400 hover:bg-slate-800 transition-colors"
                  >
                    <LogOut className="h-4 w-4" />
                    Sign Out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;
